import React from "react";
import { USER_STATE_DICTIONARY } from "consts";
//
import { AutoSuggest } from "containers/components/autoSuggest";

const UserStateAutoSuggest = (props) => {
    const suggestState = (q) => {
        if (q) {
            q = q.toLocaleLowerCase();
        }

        return Promise.resolve(
            Object.keys(USER_STATE_DICTIONARY)
                .filter(key => (USER_STATE_DICTIONARY[key] || "")
                    .toLocaleLowerCase()
                    .includes(q)
                )
        )
    }

    return (
        <AutoSuggest
            label="State"
            fetchOptions={suggestState}
            renderOption={(key) => ({label: `${USER_STATE_DICTIONARY[key]}`, value: key})}
            optionIdentifier={(value) => value}
            {...props}
        />
    );
}

export default UserStateAutoSuggest;
